module.exports = __webpack_public_path__ + "img/oiseau_qui_chante-mobile.348c5c3d.webp";